// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__01ega","ellipsis":"styles_ellipsis__nMlkZ","text2AndMoreLines":"styles_text2AndMoreLines__v5iPK","tooltipTrigger":"styles_tooltipTrigger__Jwy7_"};